export default "__VITE_ASSET__58735358__"